
import { api_host,api_auth} from '../../common/globals/constants';

export const createMaintenance = (user, name, token, begin, final, comment, titulo, objetivos) => 
fetch(api_host+`/reporte/online/indicadores/createMaintenance/?userId=${user}&name=${encodeURIComponent(JSON.stringify(name))}&token=${token}&begin=${begin}&final=${final}&comment=${encodeURIComponent(JSON.stringify(comment))}&tittle=${encodeURIComponent(JSON.stringify(titulo))}&objectives=${objetivos}&_ts=${Date.now()}`)
.then(response => response.json())

export const updateMaintenance = (id,user, token, comment, titulo, estado) => 
fetch(api_host+`/reporte/online/indicadores/updateMaintenance/?idMaintenance=${id}&userId=${user}&token=${token}&comment=${encodeURIComponent(comment)}&tittle=${encodeURIComponent(titulo)}&status=${estado}&_ts=${Date.now()}`)
.then(response => response.json())

